import { HttpService } from '@/services/http.ts'
import type { Role } from '@/services/models.ts'

export interface UserInfoResponse {
  id: string
  email: string
  first_name: string
  last_name: string
  picture: string
  otp_use_email: boolean
  created_at: string
  roles: Role[]
}

export class UserApi {
  static async userInfo(): Promise<UserInfoResponse> {
    return HttpService.get('/user/detail/', {})
  }

  static async updatePassword(old_password: string, new_password: string) {
    return HttpService.post('/user/change_password/', {
      old_password,
      new_password_1: new_password,
      new_password_2: new_password,
    })
  }

  static async updateName(first_name: string, last_name: string) {
    return HttpService.post('/user/detail/', {
      first_name,
      last_name,
    })
  }

  static async changeMFA(device: 'email' | 'authenticator', code: string | null) {
    const payload = { device }
    if (code) {
      payload['code'] = code
    }

    return HttpService.post('/user/mfa/select/', payload)
  }

  static async authenticatorQRCodeImageBlob(): Promise<string> {
    const requestUrl = import.meta.env.VITE_API_URL + '/user/otp/qr_code/'
    const response = await HttpService.getBlob(requestUrl)
    return URL.createObjectURL(response.blob)
  }
}
